import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-networkform',
  templateUrl: './networkform.component.html',
  styleUrls: ['./networkform.component.css']
})
export class NetworkformComponent implements OnInit {
title =  'Network Details';
  NE_Id: number;
  mode: any;
  data: any;
  N: any = {};
constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }

ngOnInit() {
  this.route.params.subscribe(params => {
    this.NE_Id = params['NE_Id'];
    this.mode = params['mode'];

    if (this.NE_Id > 0) {

      this.GetByIdNetwork(this.NE_Id)
    }
  });
  if (this.mode == 'View') {
    this.title = "View District ";
  }
  else if (this.mode == 'Edit') {
    this.title = "Edit District ";
  }
}

CreateNetwork(Network: NgForm) {
  debugger;
  this.data = this.userService.CreateNetwork(Network.value);
  this.data.subscribe(
    (response) => {
      Network.reset();
      Network.resetForm();
      Network.form.markAsPristine();
      Network.form.markAsUntouched();
      swal('Success!', 'Network Details Added Successfully .', 'success');
      this.router.navigate(['/home/network']);
    }, (error) => {
      if (error.status == 401) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    });
}

GetByIdNetwork(NE_Id) {
  debugger;
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.GetByIdNetwork(NE_Id);
  this.data.subscribe(
    (response: any) => {
      this.N = response;
    }, (error) => {
    });
}

UpdateNetwork(Network: NgForm) {
  debugger;
  this.data = this.userService.UpdateNetwork(this.NE_Id,Network.value);
  this.data.subscribe(
    (response) => {
      swal('Success!', ' Network details updated Successfully .', 'success');
      this.router.navigate(['/home/network']);
    }, (error) => {
      if (error.status == 401) {
        this.errorHandler.handleError(error);
      }
    });
}

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/network/networkform/networkform.component.ts